module.exports = __webpack_public_path__ + "img/pc_full.9a40f385.png";